import React, {Component} from 'react';
import PageTemplate from 'components/common/PageTemplateWow';
import WowFindContainer from 'containers/wow/WowFindContainer';

import { Helmet, HelmetProvider } from "react-helmet-async";

class WowFindPage extends Component {
  render() {
    return (
      <PageTemplate>
        <HelmetProvider>
          <Helmet>
            <title>WOWFIND - WorldofWarcraft Charater, Item Easy View Helper Site. DragonFlight Season2.</title>
            <meta name="description" content="WorldofWarcraft Charater (WCL, Raider, Simc all view), Item (sub stat Priority lookup) Easy View Helper Site." />
            <meta name='description' content='월드오브워크래프트 WCLTOP100. bis 아이템조회 용군단 시즌2' />
          </Helmet>
        </HelmetProvider>
        <WowFindContainer/>
      </PageTemplate>
    );
  }
};

export default WowFindPage